import type { PaymentConfig, PaymentNavigationService } from "../../types/payment";

/** сервис навигации */
export function createPaymentNavigationService(config: PaymentConfig): PaymentNavigationService {
	const orgId = config.route?.params?.orgId || "";

	return {
		redirectToError(): void {
			const path = `/${orgId}/errorPayment`;
			if (config.redirect) {
				config.redirect(path);
			} else if (config.router) {
				config.router.push(path);
			}
		},

		redirectToSuccess(path?: string): void {
			const targetPath = path ? `/${orgId}/${path}` : `/${orgId}/profile`;
			if (config.redirect) {
				config.redirect(targetPath);
			} else if (config.router) {
				config.router.push(targetPath);
			}
		},

		redirect(path: string): void {
			if (config.redirect) {
				config.redirect(path);
			} else if (config.router) {
				config.router.push(path);
			}
		},

		getErrorPath(): string {
			return `/${orgId}/errorPayment`;
		},

		getSuccessPath(): string {
			return `/${orgId}/profile`;
		},
	};
}
